import type { Theme } from "@mui/material/styles";
import type { ECharts } from "echarts";
import type { AnalyticsExportTheme } from "@/features/deployment-dashboard/analytics/export/types";

export function createAnalyticsExportTheme(theme: Theme): AnalyticsExportTheme {
  return {
    reportBackground: theme.palette.background.default,
    surfaceBackground: theme.palette.background.paper,
    primaryText: theme.palette.text.primary,
    secondaryText: theme.palette.text.secondary,
    accent: theme.palette.secondary.main,
  };
}

export function createEChartsPngCaptureOptions(exportTheme: AnalyticsExportTheme) {
  return {
    type: "png" as const,
    pixelRatio: 2,
    backgroundColor: exportTheme.surfaceBackground,
    excludeComponents: ["tooltip"],
  };
}

export function captureEChartsPng(
  instance: Pick<ECharts, "getDataURL">,
  exportTheme: AnalyticsExportTheme
): Blob {
  const dataUrl = instance.getDataURL(createEChartsPngCaptureOptions(exportTheme));
  return pngDataUrlToBlob(dataUrl);
}

export function pngDataUrlToBlob(dataUrl: string): Blob {
  const dataUrlPrefix = "data:image/png;base64,";
  if (!dataUrl.startsWith(dataUrlPrefix)) {
    throw new Error("Expected an ECharts PNG data URL.");
  }

  const bytes = Uint8Array.from(atob(dataUrl.slice(dataUrlPrefix.length)), (character) =>
    character.charCodeAt(0)
  );
  return new Blob([bytes], { type: "image/png" });
}
